import visa from "../../../../asset/visa.png";
import pay from "../../../../asset/pay.png";
import klarna from "../../../../asset/klarna.png";
import sepa from "../../../../asset/sepa.png";
import paypal from "../../../../asset/paypal.png";

export const dropOption = [
  { name: "orbit 1", id: "1" },
  { name: "orbit 2", id: "2" },
  { name: "orbit 3", id: "3" },
];

export const healConfig = {
  heading:'Spendenformuliar',
  type_1: 1,
  text_1: "Beitrag wahlen",
  cashChip: [
    { amount: "5", type: "EUR", id: "1", textField: false },
    { amount: "15", type: "EUR", id: "2", textField: false },
    { amount: "20", type: "EUR", id: "3", textField: false },
    { header: "individueller Beitrag", type: "EUR", id: "5", textField: true },
  ],
  type_2: 2,
  text_2: "Zeitraum wahlenn",
  lableChip: [
    { name: "enimalig", id: "1" },
    { name: "monatlich", id: "2" },
    { name: "halbjahrlich", id: "3" },
    { name: "jahrlich", id: "4" },
  ],
  type_3: 3,
  text_3: "Personliche Angabe",
  type_4: 4,
  text_4: "Offentliche Angaben",
  type_5: 5,
  text_5: "Zahlungsmethods",
  paymentChip: [
    { img: sepa, id: "1" },
    { img: klarna, id: "2" },
    { img: paypal, id: "3" },
    { img: pay, id: "4" },
    { img: visa, id: "5" },
  ],
  contact_heading: "Bankverbindung",
  lock_heading: "Sicheres Spenden",
  lock_paragraph:
    "Die Daten werden uber eine verschlusselte SSl Secure-Socket-Layer Internet-Verbindung ubertragen and sind zu jedem Zeitpunkt sicker",
};
